module.exports = __webpack_public_path__ + "media/images/badges/stride/stride-logo-badge_inactive-9d98e7374a9735b72ba0e345a4c4af95.svg";